import {
  DIcon,
  BookIcon,
  FontIcon,
  GalleryIcon,
  InstagramIcon,
  InteriorIcon,
  PaletteIcon,
  QuestionIcon,
  BrushIcon,
  SupportIcon,
} from '../../Icons';

export const navigation = [
  { name: 'Brush sets', href: '/', icon: BrushIcon, isExternal: false },
  { name: '3D Models', href: '3d-models', icon: DIcon, isExternal: false },
  { name: 'Stickers & Textures', href: 'stickers', icon: GalleryIcon, isExternal: false },
  { name: 'Interior Design', href: 'interior-design', icon: InteriorIcon, isExternal: false },
  { name: 'Fonts', href: 'fonts', icon: FontIcon, isExternal: false },
  { name: 'Color Palettes', href: 'color-palettes', icon: PaletteIcon, isExternal: false },
];

export const faq = [
  { name: 'Academy', href: '/academy', icon: BookIcon, isExternal: false },
  { name: 'How to install?', href: '/how-it-works', icon: QuestionIcon, isExternal: false },
];

export const assets = [
  {
    name: 'Our instagram',
    href: 'https://www.instagram.com/toolsforprocreate/',
    icon: InstagramIcon,
    isExternal: true,
  },
  { name: 'Support', href: 'mailto:helpdigitaltools@yahoo.com', icon: SupportIcon, isExternal: true },
];
